import { GeneralState } from './types';

export const getShortcutsModalStatusSelector = (state): GeneralState['isShortcutsModalOpen'] =>
    state.general.isShortcutsModalOpen;
